import { render, staticRenderFns } from "./Prescriptions.vue?vue&type=template&id=325c4e6c&scoped=true"
import script from "./Prescriptions.vue?vue&type=script&lang=js"
export * from "./Prescriptions.vue?vue&type=script&lang=js"
import style0 from "./Prescriptions.vue?vue&type=style&index=0&id=325c4e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325c4e6c",
  null
  
)

export default component.exports